module.exports = __webpack_public_path__ + "0ab69139e6ca60608ab5792ed8ea9be5.jpg";